import type { ReactNode } from "react";

export function Notice({
  kind = "info",
  title,
  children,
  role,
}: {
  kind?: "info" | "error" | "ok";
  title?: string;
  children?: ReactNode;
  role?: "status" | "alert";
}) {
  return (
    <div className={`notice notice-${kind}`} role={role ?? (kind === "error" ? "alert" : "status")}>
      {title && <strong>{title}</strong>}
      {children && <div className="small">{children}</div>}
    </div>
  );
}

export function Progress({ label }: { label: string }) {
  return (
    <div className="progress" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
